import { render, staticRenderFns } from "./StockItemSelect.vue?vue&type=template&id=557f9a41&"
import script from "./StockItemSelect.vue?vue&type=script&lang=ts&"
export * from "./StockItemSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports